import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Muted, Unmuted } from '@magalu/stereo-ui-icons';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { buildVideoProgressionEventData } from '../AdsBanner.utils';
import { usePublisher } from '@magalu/mixer-publisher';
import { useHlsVideo } from '../../../../hooks/useHlsVideo';
import AdsBannerSkeleton from '../../AdsBannerSkeleton';
import { MuteButton, StyledVideo, VideoWrapper } from './Video.styles';
var Video = function Video(_ref) {
  var adsPath = _ref.adsPath,
    banner = _ref.banner,
    borderRadius = _ref.borderRadius,
    height = _ref.height,
    inView = _ref.inView,
    width = _ref.width;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var eventData = useMemo(function () {
    return {
      creative_slot: adsPath,
      video_title: banner.videoTitle || '',
      video_url: banner.imageUrl
    };
  }, [banner.imageUrl, adsPath, banner.videoTitle]);
  var handleStart = useCallback(function (videoInfo) {
    publish('promotion:video:start', _extends({}, eventData, buildVideoProgressionEventData(videoInfo)));
  }, [publish, eventData]);
  var handleComplete = useCallback(function (videoInfo) {
    publish('promotion:video:complete', _extends({}, eventData, buildVideoProgressionEventData(videoInfo)));
  }, [publish, eventData]);
  var handleProgress = useCallback(function (videoInfo) {
    publish('promotion:video:progress', _extends({}, eventData, buildVideoProgressionEventData(videoInfo)));
  }, [publish, eventData]);
  var _useHlsVideo = useHlsVideo({
      autoPlay: true,
      onComplete: handleComplete,
      onProgress: handleProgress,
      onStart: handleStart,
      videoUrl: banner.imageUrl
    }),
    videoRef = _useHlsVideo.videoRef,
    isMuted = _useHlsVideo.isMuted,
    controls = _useHlsVideo.controls;
  useEffect(function () {
    if (isLoaded) {
      if (inView) {
        controls.play();
      } else {
        controls.pause();
      }
    }
  }, [inView, isLoaded, controls]);
  var handleMuteToggle = function handleMuteToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    controls.toggleMute();
  };
  return React.createElement(VideoWrapper, {
    width: width,
    height: height
  }, React.createElement(AdsBannerSkeleton, {
    isVisible: !isLoaded,
    width: width,
    height: height
  }), React.createElement(StyledVideo, {
    "aria-label": "Banner de ofertas do Magazine Luiza",
    ref: videoRef,
    height: height,
    width: width,
    playsInline: true,
    loop: true,
    style: {
      borderRadius: borderRadius,
      display: isLoaded ? 'block' : 'none',
      objectFit: 'cover'
    },
    onLoadedData: function onLoadedData() {
      return setIsLoaded(true);
    }
  }), isLoaded && React.createElement(MuteButton, {
    onClick: handleMuteToggle,
    "aria-label": isMuted ? 'Ativar som do vídeo' : 'Desativar som do vídeo',
    type: "button"
  }, isMuted ? React.createElement(Muted, {
    width: 24,
    height: 24,
    color: "white"
  }) : React.createElement(Unmuted, {
    width: 24,
    height: 24,
    color: "white"
  })));
};
process.env.NODE_ENV !== "production" ? Video.propTypes = {
  adsPath: PropTypes.string.isRequired,
  banner: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    videoTitle: PropTypes.string
  }).isRequired,
  borderRadius: PropTypes.string,
  height: PropTypes.string,
  inView: PropTypes.bool,
  width: PropTypes.string
} : void 0;
Video.defaultProps = {
  borderRadius: '8px',
  height: '100%',
  inView: true,
  width: '100%'
};
export default Video;